// Import React and styled-components
import React from 'react'
import styled from 'styled-components'

// Define the container with rounded corners and padding

// A flexbox row to align color and text side by side
const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
    width: 100%; 
`

// Define the color circle for each row
const ColorCircle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${props => props.color || 'gray'};
  margin-right: 10px;
`

// Text styles for the label
const Label = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 15.12px;
  color: #000000;
  margin-right: auto;
`

// Text styles for the range
const Range = styled.span`
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.12px;
  color: #000000;
`
const Left = styled.div`
  flex: 1; /* Allow Left to take up equal space as Right */
  display: flex;
  align-items: center; /* Align items vertically in the center */
`
const Right = styled.div`
  flex: 1; /* Allow Right to take up equal space as Left */
  display: flex;
  align-items: center; /* Align items vertically in the center */
  gap: 8px; /* Adds spacing between elements inside the Right container */
`;

const SalaryRanges = ({ roleTypewithComp }) => {

  const getOrderBasedColor = orderNo => {
    switch (orderNo) {
      case 1:
        return {
          color: '#000000',
          borderColor: '#CCCCCC',
          background: '#FAFAFB',
        }
      case 2:
        return {
          color: '#000000',
          borderColor: '#97CADB',
          background: '#E0F7FF',
        }
      case 3:
        return {
          color: '#000000',
          borderColor: '#B5A3F7',
          background: '#E7E0FF',
        }
  
      case 4:
        return {
          color: '#000000',
          borderColor: '#E1A7BA',
          background: '#FFE5ED',
        }
      case 5:
        return {
          color: '#000000',
          borderColor: '#F29F05',
          background: '#F29F0533',
        }
      case 6:
        return {
          color: '#000000',
          borderColor: '#F25C05',
          background: '#F25C0533',
        }
      case 7:
        return {
          color: '#000000',
          borderColor: '#72B06F',
          background: '#72B06F33',
        }
      case 8:
        return {
          color: '#000000',
          borderColor: '#4C1D91',
          background: '#4C1D9133',
        }
      case 9:
        return {
          color: '#000000',
          borderColor: '#02457A',
          background: '#02457A33',
        }
      case 10:
        return {
          color: '#000000',
          borderColor: '#595F33',
          background: '#595F3333',
        }
      default:
        return {}
    }
  }
  // Format the salary range text
  const formatRange = (minCTC, maxCTC) => {
    if (maxCTC) {
      return `₹${minCTC.toLocaleString()} - ₹${maxCTC.toLocaleString()}`
    }
    return `₹${minCTC.toLocaleString()}+`
  }

  return (
    <div>
      {roleTypewithComp?.map((item, index) => (
        <Row key={index}>
          <Left>
          <ColorCircle color={getOrderBasedColor(item?.orderNo)?.borderColor} />
          <Label>{item?.name}</Label>
          </Left>
          <Right>
          <Range>{formatRange(item?.minCTC, item?.maxCTC)}</Range>
          </Right>
        </Row>
      ))}
    </div>
  )
}

export default SalaryRanges
